import { render, staticRenderFns } from "./VCardTitleClose.vue?vue&type=template&id=28e35d98"
import script from "./VCardTitleClose.vue?vue&type=script&lang=js"
export * from "./VCardTitleClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports